/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useScrollLock as o } from "@vueuse/core";
const c = o(document.documentElement);
function l() {
  return c;
}
export {
  l as useGlobalScrollLock
};
